import { render, staticRenderFns } from "./ExternalContentView.vue?vue&type=template&id=a6e0bd20&scoped=true"
import script from "./ExternalContentView.vue?vue&type=script&lang=js"
export * from "./ExternalContentView.vue?vue&type=script&lang=js"
import style0 from "./ExternalContentView.vue?vue&type=style&index=0&id=a6e0bd20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e0bd20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6e0bd20')) {
      api.createRecord('a6e0bd20', component.options)
    } else {
      api.reload('a6e0bd20', component.options)
    }
    module.hot.accept("./ExternalContentView.vue?vue&type=template&id=a6e0bd20&scoped=true", function () {
      api.rerender('a6e0bd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/ExternalContentView.vue"
export default component.exports